<template>
  <div>
    <div class="upload">
      <h1
        class="upload__header"
        v-html="
          mergeHtmlContent(
            this.config.lang['account.upload.header'],
            ' ',
            this.config.tooltip['account.upload.headerhelp']
          )
        "
      ></h1>
      <div class="upload__table dropzone-settings">
        <div class="upload__section">
          <h2
            class="upload__section_header"
            v-html="
              mergeHtmlContent(
                this.config.lang['account.upload.uploadname-einzelbrief'],
                ' ',
                this.config.tooltip['account.upload.uploadhelp-einzelbrief']
              )
            "
          ></h2>
          <form
            ref="singlefileform"
            class="upload__section_download upload__section_download--einzelbrief"
            :data-jobtype="this.config.types.single.jobType"
          >
            <div
              @click="$refs.singlefile.click()"
              class="upload__section_clickable upload__section_clickable--single"
            >
              <transition name="modalfade">
                <div v-show="!isSingleProgressBarVisible">
                  <p
                    class="upload__section_action"
                    v-html="this.config.lang['account.upload.action']"
                  ></p>
                  <p
                    class="upload__section_label"
                    v-html="
                      this.config.lang['account.upload.uploadname-einzelbrief']
                    "
                  ></p>
                </div>
              </transition>
              <transition name="modalfade">
                <div
                  v-show="isSingleProgressBarVisible"
                  class="progress-bar__wrapper"
                >
                  <div class="progress-bar__upload">
                    <div
                      class="progress-bar__upload-progress"
                      ref="singleProgressBar"
                      role="progressbar"
                    >
                      <span class="progress-text" ref="singleProgressBarText"
                        >&nbsp;</span
                      >
                    </div>
                  </div>
                </div>
              </transition>
              <input
                class="display--none"
                ref="singlefile"
                type="file"
                :accept="this.config.settings['ebrief.upload.accepted_types']"
                :data-jobtype="this.config.types.single.jobType"
                multiple
              />
            </div>
            <span class="dz-message dz-error"></span>
          </form>
          <p class="upload__section_formatinfo">
            <span
              v-html="
                this.config.lang['account.upload.formatinfo-section.text']
              "
            ></span>
            <a
              :href="this.config.routes['ebrief_account_help_submittals']"
              v-html="
                this.config.lang['account.upload.formatinfo-section.link']
              "
            ></a>
          </p>
        </div>
        <div class="upload__section">
          <h2
            class="upload__section_header"
            v-html="
              mergeHtmlContent(
                this.config.lang['account.upload.uploadname-serienbrief'],
                ' ',
                ' '
              )
            "
          ></h2>
          <form
            ref="bulkfileform"
            class="upload__section_download upload__section_download--serienbrief"
            :data-jobtype="this.config.types.bulk.jobType"
          >
            <div
              @click="$refs.bulkfile.click()"
              class="upload__section_clickable upload__section_clickable--bulk"
            >
              <transition name="modalfade">
                <div v-show="!isBulkProgressBarVisible">
                  <p
                    class="upload__section_action"
                    v-html="this.config.lang['account.upload.action']"
                  ></p>
                  <p
                    class="upload__section_label"
                    v-html="
                      this.config.lang['account.upload.uploadname-serienbrief']
                    "
                  ></p>
                </div>
              </transition>
              <transition name="modalfade">
                <div
                  v-show="isBulkProgressBarVisible"
                  class="progress-bar__wrapper"
                >
                  <div class="progress-bar__upload">
                    <div
                      class="progress-bar__upload-progress"
                      ref="bulkProgressBar"
                      role="progressbar"
                    >
                      <span class="progress-text" ref="bulkProgressBarText"
                        >&nbsp;</span
                      >
                    </div>
                  </div>
                </div>
              </transition>
              <input
                class="display--none"
                ref="bulkfile"
                type="file"
                :accept="this.config.settings['ebrief.upload.accepted_types']"
                :data-jobtype="this.config.types.bulk.jobType"
                multiple
              />
            </div>
            <span class="dz-message"></span>
          </form>
          <p class="upload__section_formatinfo">
            <span
              v-html="
                this.config.lang['account.upload.formatinfo-section.text']
              "
            ></span>
            <a
              :href="this.config.routes['ebrief_account_help_submittals']"
              v-html="
                this.config.lang['account.upload.formatinfo-section.link']
              "
            ></a>
          </p>
        </div>
      </div>
      <p class="upload__formatinfo_mobile">
        <span
          v-html="this.config.lang['account.upload.formatinfo-section.text']"
        ></span>
        <a
          :href="this.config.routes['ebrief_account_help_submittals']"
          v-html="this.config.lang['account.upload.formatinfo-section.link']"
        ></a>
      </p>
    </div>
    <transition name="modalfade">
      <SingleLetterControl
        v-show="isSingleLetterControlVisible"
        :configdata="configdata"
        :jobcount="jobcount"
        :filelist="this.files"
        :attachmentlist="this.attachments"
        @update-files="updateFiles"
        @update-attachments="updateAttachments"
        @submit-upload="submitUpload"
        @close-single-modal="closeSingleModal"
        @open-error-modal="openErrorModal"
      />
    </transition>
    <transition name="modalfade">
      <BulkLetterControl
        v-show="isBulkLetterControlVisible"
        :configdata="configdata"
        :jobcount="jobcount"
        :filelist="this.files"
        :attachmentlist="this.attachments"
        @update-files="updateFiles"
        @update-attachments="updateAttachments"
        @submit-upload="submitUpload"
        @close-bulk-modal="closeBulkModal"
        @open-error-modal="openErrorModal"
      />
    </transition>
    <transition name="modalfade">
      <UploadErrorModal
        v-show="isErrorModalVisible"
        :configdata="configdata"
        :errordata="errordata"
        @close-error-modal="closeErrorModal"
      />
    </transition>
  </div>
</template>
<script>
import UploadService from "../services/UploadService";
import ValidationService from "../services/ValidationService";
import SingleLetterControl from "./SingleLetterControl";
import BulkLetterControl from "./BulkLetterControl";
import UploadErrorModal from "./UploadErrorModal";

export default {
  name: "DropUpload",
  components: {
    SingleLetterControl,
    BulkLetterControl,
    UploadErrorModal
  },
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    jobcount: {
      type: Number,
      default: () => 0
    },
    incart: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      files: [],
      jobs: {},
      attachments: [],
      dragAndDropCapable: false,
      isSingleLetterControlVisible: false,
      isBulkLetterControlVisible: false,
      isErrorModalVisible: false,
      isSingleProgressBarVisible: false,
      isBulkProgressBarVisible: false,
      errordata: {},
      validation: new ValidationService(configdata)
    };
  },
  computed: {
    config: function() {
      return configdata;
    }
  },
  methods: {
    mergeHtmlContent(string1, string2, string3) {
      return string1 + string2 + string3;
    },
    determineDragAndDropCapable() {
      let div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    updateFiles(update) {
      this.files = update;
    },
    updateAttachments(update) {
      this.attachments = update;
    },
    submitUpload(parameter) {
      let formData = new FormData();
      formData.append("jobType", parameter.jobType);
      formData.append("colorType", parameter.colorType);
      formData.append("printType", parameter.printType);
      formData.append("paperType", parameter.paperType);
      formData.append("shipmentType", parameter.shipmentType);
      formData.append("splitingType", parameter.splitingType);
      formData.append("splitingValue", parameter.splitingValue);
      formData.append("letterType", parameter.letterType);
      formData.append("attachments", this.attachments.length);

      if (parameter.returnEnvelopeType) {
        formData.append("returnEnvelopeType", parameter.returnEnvelopeType);
        formData.append("returnAddress", parameter.returnAddress);
      }

      let that = this;
      for (let i = 0; i < that.files.length; i++) {
        let file = that.files[i];
        // if (this.attachments.length > 0) {
        //     let name = file.name;
        //     file = that.renameFile(file, 'd_'+name);
        // }
        formData.append("files[" + i + "]", file);
      }

      for (let i = 0; i < that.attachments.length; i++) {
        let attachment = that.attachments[i];
        formData.append("attachments[" + i + "]", attachment);
      }

      let uploadConfig = {
        onUploadProgress: function(progressEvent) {
          if (parameter.jobType === that.config.printparameter.single.jobType) {
            that.isSingleProgressBarVisible = true;
          }
          if (parameter.jobType === that.config.printparameter.bulk.jobType) {
            that.isBulkProgressBarVisible = true;
          }
          let percentCompleted = 0;
          percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (parameter.jobType === that.config.printparameter.single.jobType) {
            $(that.$refs.singleProgressBar)
              .css("width", percentCompleted + "%")
              .text();
            $(that.$refs.singleProgressBarText).text(percentCompleted + "%");
          }
          if (parameter.jobType === that.config.printparameter.bulk.jobType) {
            $(that.$refs.bulkProgressBar).css("width", percentCompleted + "%");
            $(that.$refs.singleProgressBarText).text(percentCompleted + "%");
          }
          if (percentCompleted === 100) {
            that.$emit("show-spinner-modal");
          }
        }
      };
      UploadService.uploadFiles(
        this.config.routes["ebrief_upload"],
        formData,
        uploadConfig
      ).then(response => {
        that.isSingleProgressBarVisible = false;
        that.isBulkProgressBarVisible = false;
        that.isSingleLetterControlVisible = false;
        that.isBulkLetterControlVisible = false;
        this.files = [];
        this.attachments = [];
        if (response.success) {
          this.$emit("add-uploaded-jobs", response.jobs);
        } else {
          this.$emit("upload-files-error");
        }
      });
    },
    closeSingleModal() {
      this.isSingleLetterControlVisible = false;
    },
    closeBulkModal() {
      this.isBulkLetterControlVisible = false;
    },
    closeErrorModal(openControl) {
      this.isErrorModalVisible = false;
      if (openControl === this.config.printparameter.single.jobType) {
        this.isSingleLetterControlVisible = true;
      } else if (openControl === this.config.printparameter.bulk.jobType) {
        this.isBulkLetterControlVisible = true;
      }
    },
    openErrorModal(errorData) {
      if (errorData.jobType === this.config.printparameter.single.jobType) {
        this.isSingleLetterControlVisible = false;
      }
      if (errorData.jobType === this.config.printparameter.bulk.jobType) {
        this.isBulkLetterControlVisible = false;
      }
      this.errordata = errorData;
      this.isErrorModalVisible = true;
    },
    openControl(jobType) {
      if (jobType === this.config.printparameter.single.jobType) {
        this.isSingleLetterControlVisible = true;
      }
      if (jobType === this.config.printparameter.bulk.jobType) {
        this.isBulkLetterControlVisible = true;
      }
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified
      });
    }
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          /*
           * Für alle Upload-Formulare:
           */
          [this.$refs.singlefileform, this.$refs.bulkfileform].forEach(function(
            form
          ) {
            form.addEventListener(
              evt,
              function(e) {
                e.preventDefault();
                e.stopPropagation();
              }.bind(this),
              false
            );
          });
        }.bind(this)
      );
      let that = this;
      /*
       * Für alle Upload-Formulare:
       */
      [this.$refs.singlefileform, this.$refs.bulkfileform].forEach(function(
        form
      ) {
        form.addEventListener(
          "drop",
          function(e) {
            that.validation.startValidation(
              $(form).data("jobtype"),
              that.jobcount + that.incart
            );
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
              if (
                that.validation.checkFileIsValid(
                  e.dataTransfer.files[i],
                  that.files
                )
              ) {
                that.files.push(e.dataTransfer.files[i]);
              }
            }
            that.errordata = that.validation.getValidation();
            if (that.errordata.countErrors > 0) {
              that.isErrorModalVisible = true;
            } else {
              that.openControl($(form).data("jobtype"));
            }
          }.bind(this)
        );
      });
      [this.$refs.singlefile, this.$refs.bulkfile].forEach(function(input) {
        input.addEventListener(
          "change",
          function(e) {
            that.validation.startValidation(
              $(input).data("jobtype"),
              that.jobcount + that.incart
            );
            for (let i = 0; i < e.target.files.length; i++) {
              if (
                that.validation.checkFileIsValid(e.target.files[i], that.files)
              ) {
                that.files.push(e.target.files[i]);
              }
            }
            that.errordata = that.validation.getValidation();
            input.value = "";
            if (that.errordata.countErrors > 0) {
              that.isErrorModalVisible = true;
            } else {
              that.openControl($(input).data("jobtype"));
            }
          }.bind(this)
        );
      });
    } else {
      console.error("NotDragAndDropCapable");
    }
  }
};
</script>
